export async function waitForElement(
	elementId: string,
	timeout: number | undefined,
): Promise<HTMLElement | null> {
	const startTime = Date.now();

	return new Promise((resolve) => {
		const checkElement = () => {
			const element = document.getElementById(elementId);
			if (element) {
				resolve(element);
			} else if (!timeout || Date.now() - startTime < timeout) {
				requestAnimationFrame(checkElement);
			} else {
				resolve(null);
			}
		};

		requestAnimationFrame(checkElement);
	});
}
